import { SelectOutlined } from "@ant-design/icons";
import { VerifiedUserOutlined } from "@mui/icons-material";
import { Button, Form, Modal } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import DataTable from "../../../../Components/DataTable/DataTable";
import CheckPermission from "../../../../Util/CheckPermission";
import ExportExcel from "../../../../Util/ExportExcel";
import { dataFetchError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import * as actions from "../../../../store/actions/action";

const Roles = ({ LoadingSetter, ClearLoading, loading, permissions }) => {
  const [data, setData] = useState([]);
  const [permissionsModal, setPermissionsModal] = useState(null);
  const columns = [
    {
      title: "اسم نقش",
      dataIndex: "name",
      searchable: true,
      width: "20%",
    },
    {
      title: "توضیحات",
      dataIndex: "description",
      width: "20%",
    },
    {
      title: "تعداد کاربر",
      dataIndex: "users",
      width: "10%",
      editable : false
    },
  ];
  const loadData = () => {
    LoadingSetter();
    api
      .get("/userrequests/list")
      .then((res) => {
        const uni = [];
        let data = [];
        res.data
          .sort((a, b) => {
            const aDate = new Date(a.createdAt);
            const bDate = new Date(b.createdAt);
            return bDate - aDate;
          })
          .forEach((user) => {
            console.log(user.mobile);
            const mobile = user.mobile ? user.mobile : user.user;
            if (!uni.includes(mobile)) {
              uni.push(mobile);
              data.push({
                ...user,
                mobile,
                signup_status: user.user ? true : false,
                count: 1,
              });
            } else {
              data = data.map((val) => {
                if (mobile === val.mobile) {
                  return {
                    ...val,
                    count: val.count ? val.count + 1 : 1,
                  };
                } else {
                  return val;
                }
              });
            }
          });
        setData(data);
        ClearLoading();
        console.log(data);
      })

      .catch((err) => {
        console.log(err);
        ClearLoading();
        dataFetchError();
      });
  };

  useEffect(() => {
    loadData();
    // loadFlagsData();
  }, []);
  const exportData = () => {
    const json = data.map((user) => {
      const newUser = {};
      Object.keys(user).forEach((key) => {
        let title = null;
        columns.forEach((c) => {
          if (c.dataIndex === key) {
            title = c.title;
          }
        });
        if (title) {
          newUser[title] = user[key];
        }
      });
      return newUser;
    });
    ExportExcel(json, "گزارش درخواست مشاوره");
  };
  return (
    <>
      <DataTable
        id="UsersReport"
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        hideComment
        hideErrorReport
        operationExtra={(record) => {
          return (
            <Button
              onClick={() => {
                setPermissionsModal(record);
              }}
              icon={<SelectOutlined />}
              type="primary"
            >
              تعیین دسترسی
            </Button>
          );
        }}
        editable
        keepPageOnSave
        header={{
          title: "نقش‌ها",
          avatar: {
            icon: (
              <VerifiedUserOutlined
                sx={{ position: "relative", top: "0.4rem" }}
              />
            ),
            size: "large",
          },
          extra: CheckPermission("export_excel", permissions) && (
            <Button onClick={exportData}>خروجی اکسل</Button>
          ),
        }}
      />
      {permissionsModal && (
        <Modal
          footer={[]}
          open
          onCancel={() => {
            setPermissionsModal(null);
          }}
          title={`تعیین دسترسی برای نقش ${permissionsModal.name}`}
        >
          <h2>لیست دسترسی‌ها</h2>
          <Form></Form>
        </Modal>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Roles);
